package fr.manyverse.app.domain.model

import kotlinx.serialization.Serializable

@Serializable
enum class MemberRole {
    GAME_MASTER,
    PLAYER
}
